import React, { useEffect, useState } from "react";
import ModalLayout from "../../../../../components/ModalLayout";
import MultipleSimple from "../../../../../../media/images/icons/multiple-simple";
import { Box, Typography, useTheme } from "@mui/material";
import TenderInfo from "./TenderInfo";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../hooks/useRedux";
import useSWRMutation from "swr/mutation";
import {
  setOpenSnackbar,
  setSnackbarChildren,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../../../redux/features/snackbarSlice";
import { fetcherPost } from "../../../../../../services/fetcher";
import InfoCircle from "../../../../../../media/images/icons/info-circle";
import BigCar3 from "../../../../../../media/images/icons/bigcar3";
import DolorSingle from "../../../../../../media/images/icons/dolor-single";
import { addCommas } from "@persian-tools/persian-tools";
import CustomButton from "../../../../../components/CustomButton";
import EditFillSVG from "../../../../../../media/images/icons/editfill-icon";
import ArrowUpFillSVG from "../../../../../../media/images/icons/arrow-up";
import PriceInput from "./PriceInput";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import ArrowLeftSVG from "../../../../../../media/images/icons/arrow-left";
interface Props {
  handleDeleteTender: (id: string) => void;
  handleEditPrice: (id: string, price: any) => void;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  orderId: string;
  id: string;
  status: number;
  price: number;
}

export interface ITenderOfferDeatails {
  description: "توضیحات";
  ladingLocationAddress: "ععب";
  orderDate: "1403/06/06";
  companyTel: null;
  companyAddress: null;
  orderCode: null;
  id: "66cdc027a5cd1da174714f96";
  orderId: "209995303418";
  loaderTypeName: null;
  goodsName: "نارنج";
  source: "تهران";
  sourceCode: 0;
  destination: "کرمان";
  destinationCode: 0;
  fare: 16500000;
  ladingDate: "1403/06/06";
  ladingDateTo: "1403/06/06";
  ladingTime: "16:16";
  ladingTimeTo: "19:19";
  companyCode: "1100111";
  companyName: "شرکت پیرامید";
  packageTypeName: null;
  weight: 15000;
  remainder: 10;
  nobatCountRemainder: 8;
  terminalName: null;
  salonCode: 0;
  salonName: "سالن ورودی یک";
  loaderTypeGroup: "اطاقدار تک";
  truckCount: 0;
  nobatCount: 0;
  orderSalonType: null;
  orderSalonTypeInt: null;
  loaderTypeGroupSec: null;
  truckWeight: 0;
  truckWeightTo: 0;
  fareAmountPerKg: null;
  reserved: 0;
  referenceCode: null;
  truckCountCompany: null;
  ladingLocationInfoCityName: null;
  ladingLocationInfoAddress: null;
  orderDateEn: null;
  receiverInfoName: null;
  status: number;
}
export default function TenderDeatailsModal(props: Props) {
  const {
    open,
    setOpen,
    orderId,
    status,
    price,
    id,
    handleDeleteTender,
    handleEditPrice,
  } = props;

  const theme = useTheme();

  const dispatch = useAppDispatch();
  const [priceValue, setPriceValue] = useState("");

  const { salonInfo } = useAppSelector(
    (state) => state.user.driverNobatQueueInfo
  );
  const [editable, setEditable] = useState(false);

  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      orderId: "",
      price: "",
    },
    validationSchema: yup.object().shape({
      price: yup.string().required("این فیلد الزامی است!"),
    }),
    validateOnChange: true,
    onSubmit: (values) => {
      postTenderOffer({
        price: Number(values.price),
        orderId: orderId,
      });
      // .catch((e) => {
      //   dispatch(setOpenSnackbar(true));
      //   dispatch(setSnackbarErrorStatus(e.response.data.errorCode));
      //   dispatch(setSnackbarDescription(e.response.data.error));
      //   if (!salonInfo)
      //     dispatch(
      //       setSnackbarChildren(
      //         <CustomButton
      //           flex={1}
      //           // loading={true}
      //           flexDirection="row-reverse"
      //           justifyContent="center"
      //           onClick={() => {
      //             navigate("../check-in");
      //             dispatch(setOpenSnackbar(false));
      //           }}
      //           title="اعلام حضور"
      //           bgColor="primary.main"
      //           textColor="#fff"
      //           fWeight="700"
      //           px="10px"
      //           py="12px"
      //           mt="12px"
      //           borderRadius="10px"
      //           icon1={<ArrowLeftSVG size={26} color={"#fff"} />}
      //         />
      //       )
      //     );
      // });
    },
  });

  const { trigger: postTenderOffer } = useSWRMutation(
    [`/DriverPriceReq/Insert`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: () => {
        handleEditPrice(id, formik.values.price);
        formik.resetForm();
        setPriceValue("");
        setEditable(false);
      },
    }
  );

  const {
    data: singleTender,
    trigger: getSingleTender,
    // isMutating: isgetActiveCargoMutting,
  } = useSWRMutation(
    [`/Order/GetById`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: () => {
        // setTenderDeatails(data);
      },
    }
  );

  const { trigger: deleteTenderOffer } = useSWRMutation(
    [`/DriverPriceReq/Remove`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: () => {
        handleDeleteTender(id);
        setOpen(false);
      },
    }
  );

  useEffect(() => {
    if (open) {
      getSingleTender({
        id: orderId,
      });
    }
  }, [open]);

  const handleChangePrice = (e: React.ChangeEvent<HTMLInputElement>) => {
    let { value } = e.target;
    if (value.startsWith("0") && value.length > 1 && value[1] !== ".") {
      value = value.slice(1);
    }
    const numericValue = value.replace(/[^\d]/g, ""); // Remove non-numeric characters
    const formattedValue = addCommas(numericValue); // Format the value with commas
    formik.setFieldValue("price", numericValue); // Update Formik's field value
    setPriceValue(formattedValue);
    // setPriceWord(numberToWords(String(Math.trunc(Number(numericValue) / 10))));
  };

  return (
    <ModalLayout open={open} setOpen={setOpen}>
      <Box
        sx={{
          flex: 1,
          // paddingX: "8px",
          overflowY: "auto",
        }}
      >
        <Box
          sx={{
            padding: "4px",
            // borderStyle: "solid",
            // borderColor: "info.main",
            borderWidth: "1px",
            borderRadius: "10px",
          }}
        >
          <TenderInfo {...singleTender} status={status} />
          <Box
            sx={{
              mt: 2,
              padding: "6px",
              backgroundColor: theme.palette.primary[50],
              borderRadius: "8px",
              gap: "4px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <InfoCircle color={theme.palette.primary.main} />
            <Typography
              sx={{
                fontSize: "12px",
              }}
              color="primary.main"
            >
              تا زمانی که بار به راننده‌‌ای اختصاص پیدا نکرده، مبلغ پیشنهادی شما
              فعال است و بعد به صورت خودکار حذف می‌شود.
            </Typography>
          </Box>
          <Box
            sx={{
              mt: 2,
              display: "flex",
              flexDirection: "column",
              gap: "8px",
            }}
          >
            <Box
              sx={{
                borderWidth: "1px",
                borderColor: "info.light",
                borderStyle: "solid",
                padding: "8px 4px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderRadius: "8px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <BigCar3 color={theme.palette.textColor.main} />
                <Typography
                  sx={{
                    fontSize: "14px",
                  }}
                >
                  گروه بارگیر:
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontSize: "14px",
                }}
                color="secondary.main"
              >
                {singleTender?.loaderTypeGroup}
              </Typography>
            </Box>
            <Box
              sx={{
                borderWidth: "1px",
                borderColor: "info.light",
                borderStyle: "solid",
                padding: "8px 4px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderRadius: "8px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <DolorSingle color={theme.palette.textColor.main} />
                <Typography
                  sx={{
                    fontSize: "14px",
                  }}
                >
                  کرایه اعلام شده بار:
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "4px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "14px",
                  }}
                  color="success.main"
                >
                  {addCommas(singleTender?.fare || 0)} ریال
                </Typography>
              </Box>
            </Box>

            {editable ? (
              <>
                <Box
                  sx={{
                    borderWidth: "1px",
                    borderColor: "info.light",
                    borderStyle: "solid",
                    padding: "8px 4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderRadius: "8px",
                    backgroundColor: "info.light",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    <ArrowUpFillSVG color={theme.palette.textColor.main} />
                    <Typography variant="body2"> آخرین پیشنهاد شما:</Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      gap: "4px",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="body1" color="primary.main">
                      {addCommas(price)}
                    </Typography>
                    <Typography color="primary.main">ریال</Typography>
                  </Box>
                </Box>
                <Typography
                  textAlign={"center"}
                  variant="body1"
                  color={"secondary.main"}
                >
                  کرایه پیشنهادی جدید خود را وارد کنید
                </Typography>
                {/* <Box
                  sx={{
                    borderRadius: "10px",
                    borderColor: "info.main",
                    borderWidth: "1px",
                    borderStyle: "solid",
                    backgroundColor: "info.light",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <TextField
                    type="number"
                    placeholder="-----"
                    sx={{
                      textAlign: "left",
                      direction: "ltr",
                      flex: 1,
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "none !important",
                        outline: "none !important",
                      },
                      "& .MuiInputBase-input": {
                        //   border: "none !important",
                        outline: "none !important",
                      },
                      "& .MuiInputBase-root": {
                        border: "none !important",
                        outline: "none !important",
                      },
                      border: "none",
                    }}
                  />
                  <Typography width={"45%"}>ریال</Typography>
                </Box> */}
                <PriceInput
                  handleChangeInput={handleChangePrice}
                  name="price"
                  value={priceValue}
                  error={formik.touched.price && Boolean(formik.errors.price)}
                />
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <CustomButton
                    rippleColor={theme.palette.info.dark}
                    flex={1}
                    // loading
                    justifyContent="center"
                    flexDirection="row-reverse"
                    onClick={() => {
                      formik.handleSubmit();
                    }}
                    title="تایید و ارسال جدید"
                    bgColor="success.main"
                    px="10px"
                    py="12px"
                    borderRadius="10px"
                    icon1={<EditFillSVG size={22} color={"#fff"} />}
                  />
                  <CustomButton
                    type="outlined"
                    rippleColor={theme.palette.info.dark}
                    // loading
                    //   flexDirection="row-reverse"
                    onClick={() => setEditable(false)}
                    title="انصراف"
                    bgColor={theme.palette.primary[50]}
                    textColor="primary.main"
                    borderColor="primary.main"
                    px="10px"
                    py="12px"
                    borderRadius="10px"
                    icon2={
                      <MultipleSimple
                        color={theme.palette.primary.main}
                        size={18}
                      />
                    }
                  />
                </Box>
              </>
            ) : (
              <>
                <Box
                  sx={{
                    borderWidth: "1px",
                    borderColor: "info.light",
                    borderStyle: "solid",
                    padding: "8px 4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderRadius: "8px",
                    backgroundColor: theme.palette.primary[50],
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    <ArrowUpFillSVG color={theme.palette.textColor.main} />
                    <Typography
                      sx={{
                        fontSize: "14px",
                      }}
                    >
                      کرایه پیشنهادی شما:
                    </Typography>
                  </Box>
                  <Typography
                    sx={{
                      fontSize: "14px",
                    }}
                    color="primary.main"
                  >
                    {addCommas(price)} ریال
                  </Typography>
                </Box>
                <CustomButton
                  rippleColor={theme.palette.info.dark}
                  flex={1}
                  // loading
                  justifyContent="center"
                  onClick={() => setEditable(true)}
                  title="ویرایش پیشنهاد"
                  bgColor="primary.main"
                  textColor="#fff"
                  fSize="16px"
                  px="10px"
                  py="12px"
                  borderRadius="10px"
                  icon1={<EditFillSVG size={22} />}
                />
                <CustomButton
                  type="outlined"
                  rippleColor={theme.palette.info.dark}
                  flex={1}
                  // loading
                  //   flexDirection="row-reverse"
                  onClick={() =>
                    deleteTenderOffer({
                      id,
                    })
                  }
                  justifyContent="center"
                  title="حذف پیشنهاد"
                  bgColor="error.light"
                  textColor="error.main"
                  borderColor="error.main"
                  fWeight="700"
                  fSize="16px"
                  px="10px"
                  py="12px"
                  borderRadius="10px"
                  icon1={
                    <MultipleSimple
                      color={theme.palette.error.main}
                      size={18}
                    />
                  }
                />
              </>
            )}
            <CustomButton
              type="outlined"
              // rippleColor={theme.palette.info.dark}
              // loading
              //   flexDirection="row-reverse"
              onClick={() => setOpen(false)}
              justifyContent="center"
              title="بستن جزییات"
              bgColor="secondary.main"
              textColor="#fff"
              // borderColor="error.main"
              fWeight="700"
              fSize="16px"
              px="10px"
              py="12px"
              borderRadius="10px"
              // icon1={
              //   <MultipleSimple color={theme.palette.error.main} size={18} />
              // }
            />
          </Box>
        </Box>
      </Box>
    </ModalLayout>
  );
}
